import {IWidgetControllerConfig} from '@wix/native-components-infra';
import {Logger} from '@wix/web-bi-logger/dist/src/types';
import {createOOIWebBILogger} from '@wix/wixstores-client-core';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {
  cartCartIconLoaded,
  cartClickOnCartIconToOpenMiniCart,
  clickToViewCartPage,
} from '@wix/bi-logger-ecom-platform-data/v2';

export class BIService {
  private readonly biLogger: Logger;
  constructor(
    private readonly viewerContext: ViewerContext,
    private readonly controllerConfig: IWidgetControllerConfig
  ) {
    this.biLogger = this.createBILogger(controllerConfig, viewerContext);
  }

  public reportCartIconLoaded({
    cartId,
    shouldOpenSideCartFromSettings,
  }: {
    cartId?: string;
    shouldOpenSideCartFromSettings: boolean;
  }) {
    void this.biLogger.report(
      cartCartIconLoaded({
        isMobileFriendly: this.controllerConfig.wixCodeApi.window.isMobileFriendly,
        navigationClick: shouldOpenSideCartFromSettings ? 'mini cart' : 'cart',
        cartId,
      })
    );
  }

  public reportClickToOpenSideCart({cartId, itemsCount}: {cartId?: string; itemsCount?: number}) {
    void this.biLogger.report(
      cartClickOnCartIconToOpenMiniCart({
        cartId,
        itemsCount,
        viewMode: this.viewerContext.getViewMode().toLowerCase(),
        isNavigateCart: false,
      })
    );
  }

  public reportClickToNavigateToCart({
    cartId,
    itemsCount,
    origin,
  }: {
    cartId?: string;
    itemsCount?: number;
    origin: string;
  }) {
    void this.biLogger.report(
      clickToViewCartPage({
        cartId,
        itemsCount,
        viewMode: this.viewerContext.getViewMode().toLowerCase(),
        origin,
        isNavigateCart: true,
      })
    );
  }

  private createBILogger(controllerConfig: IWidgetControllerConfig, viewerContext: ViewerContext) {
    const bi = controllerConfig.platformAPIs.bi!;
    const user = viewerContext.getViewMode() === 'Site' ? {visitor_id: bi.visitorId} : {uuid: bi.ownerId};
    return createOOIWebBILogger({
      biLoggerFactory: controllerConfig.platformAPIs.biLoggerFactory!,
      user,
      biToken: bi.biToken,
      defaults: {
        storeId: viewerContext.getEcomPlatformInstanceId(),
        editorMode: viewerContext.getDeviceType() === 'Desktop' ? 'desktop' : 'mobile',
        isMerchant: false,
        appName: 'Stores',
        _msid: bi.metaSiteId,
      },
    });
  }
}
